<script lang="ts">
	let {
		unitFeatures,
		propertyFeatures,
		includedInRent
	}: { unitFeatures: string[]; propertyFeatures: string[]; includedInRent: string[] } = $props();

	function splitFeatureString(featureString: string) {
		return featureString.split(/(?=[A-Z])/).join(" ");
	}
</script>

<div class="mb-8 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
	<!-- Unit Features -->
	<div class="border-border bg-card rounded border p-4">
		<h3 class="mb-2 text-lg font-semibold">Unit Features</h3>
		<ul class="text-muted-foreground list-disc space-y-1 pl-5">
			{#if unitFeatures.length > 0}
				{#each unitFeatures as feature}
					<li>{splitFeatureString(feature)}</li>
				{/each}
			{:else}
				<li>No unit features listed.</li>
			{/if}
		</ul>
	</div>

	<!-- Property Features -->
	<div class="border-border bg-card rounded border p-4">
		<h3 class="mb-2 text-lg font-semibold">Property Features</h3>
		<ul class="text-muted-foreground list-disc space-y-1 pl-5">
			{#if propertyFeatures.length > 0}
				{#each propertyFeatures as feature}
					<li>{splitFeatureString(feature)}</li>
				{/each}
			{:else}
				<li>No property features listed.</li>
			{/if}
		</ul>
	</div>

	<!-- Included in Rent -->
	<div class="border-border bg-card rounded border p-4">
		<h3 class="mb-2 text-lg font-semibold">Included in Rent</h3>
		<ul class="text-muted-foreground list-disc space-y-1 pl-5">
			{#if includedInRent.length > 0}
				{#each includedInRent as feature}
					<li>{splitFeatureString(feature)}</li>
				{/each}
			{:else}
				<li>No inclusions listed.</li>
			{/if}
		</ul>
	</div>
</div>
